SP.lang.Class.define("SP.sitekit.form.field.Image", {
	extend: "SP.sitekit.form.field.File"
});
